import { render, staticRenderFns } from "./fileEdit.vue?vue&type=template&id=3a44cee6&"
import script from "./fileEdit.vue?vue&type=script&lang=ts&"
export * from "./fileEdit.vue?vue&type=script&lang=ts&"
import style0 from "./fileEdit.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports